// extracted by mini-css-extract-plugin
export var productImage = "_lf-1";
export var viewLink = "_lf-2";
export var wishlistItem = "_lf-0";